export default __webpack_public_path__ + "media/images/images/flags/il-d04884d7ce090451f068efab5005ae9c.png";